/**
 * Utility function to get a cookie value by name
 * @param name - The name of the cookie
 * @returns The cookie value, or undefined if not found
 */
export function getCookie(name: string): string | undefined {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));

  return match ? decodeURIComponent(match[2]) : undefined;
}

/**
 * Utility function to set a cookie
 * @param name - The name of the cookie
 * @param value - The value of the cookie
 * @param options - Optional settings for the cookie
 */
export function setCookie(
  name: string,
  value: string,
  options: {
    expires?: number | Date;
    path?: string;
    domain?: string;
    secure?: boolean;
    sameSite?: 'Lax' | 'Strict' | 'None';
  } = {}
): void {
  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)};`;

  if (options.expires) {
    const expires =
      options.expires instanceof Date
        ? options.expires.toUTCString()
        : new Date(Date.now() + options.expires * 1000).toUTCString();
    cookieString += `expires=${expires};`;
  }

  if (options.path) cookieString += `path=${options.path};`;
  if (options.domain) cookieString += `domain=${options.domain};`;
  if (options.secure) cookieString += `Secure;`;
  if (options.sameSite) cookieString += `SameSite=${options.sameSite};`;

  document.cookie = cookieString;
}
